import { render, staticRenderFns } from "./FourthSectionMaskExCard.vue?vue&type=template&id=39fd18e0&scoped=true"
import script from "./FourthSectionMaskExCard.vue?vue&type=script&lang=js"
export * from "./FourthSectionMaskExCard.vue?vue&type=script&lang=js"
import style0 from "./FourthSectionMaskExCard.vue?vue&type=style&index=0&id=39fd18e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fd18e0",
  null
  
)

export default component.exports